/**
 * 引数で渡されたパスを新しいタブで開く。
 * `history.push('/path')`をそのまま`openAsNewTab('/path')`として使える。
 *
 * @param {string} absPath 新しいタブで開くURLや絶対パス。同じbase urlの際は相対パスでも可。
 */
export const openAsNewTab = (absPath: string): void => {
  const win = window.open(absPath, '_blank');
  if (win !== null) {
    win.focus();
  }
};
